const snapshotLinks = {
  '01': 'https://lsc-live.box.com/s/nmyaseuflv6w81p002ff3igv6b79rw7q', //Alabama
  '02': 'https://lsc-live.box.com/s/byirelo8twtodkojzayjsn21vzk9yzic', //Alaska
  '04': 'https://lsc-live.box.com/s/ndumyd7r35unoqittj4piax8znpjf9eh', //Arizona
  '05': 'https://lsc-live.box.com/s/v8b3nvemyx1cukclgvef71o9tndx8mpd', //Arkansas
  '06': 'https://lsc-live.box.com/s/jkv2ads2hqs946hb9i5musy4war8wvro', //California
  '08': 'https://lsc-live.box.com/s/b9crt60h2i87sqsjai6f7vvsos4bdemw', //Colorado
  '09': 'https://lsc-live.box.com/s/02xf1ulffvulv66dfowa2h1sceya9hqb', //Connecticut
  '10': 'https://lsc-live.box.com/s/9yu5f4gcqcgrnq41tglgxmf2obf8euo4', //Delaware
  '11': 'https://lsc-live.box.com/s/7dgvxj1m0uz89ixqbpz4k3j0eydpfonw', //DC
  '12': 'https://lsc-live.box.com/s/95ujmw6hngywj06r7c8of67qb4shw9ha', //Florida
  '13': 'https://lsc-live.box.com/s/qmgt8v3u989bq7w4smmge8x7bglchflc', //Georgia
  '15': 'https://lsc-live.box.com/s/mdv15jkr26bihzn539hxvs558j5ayp75', //Hawaii
  '16': 'https://lsc-live.box.com/s/xa63ye8zzt5u856e3p45rmq2e2ifyec6', //Idaho
  '17': 'https://lsc-live.box.com/s/5e5vb0gaq8czq7rze429kw81uapi0zv9', //Illinois
  '18': 'https://lsc-live.box.com/s/0r5gtc36vicnmivgq1sgddsmx8x1be48', //Indiana
  '19': 'https://lsc-live.box.com/s/92a20jdfo09kxql8llrh19ito7p0z2e8', //Iowa
  '20': 'https://lsc-live.box.com/s/hyosqhitkm6akbrtb752qc8vuf0uagy6', //Kansas
  '21': 'https://lsc-live.box.com/s/ljicyp4d71xih1i017ftafutoft7ssrx', //Kentucky
  '22': 'https://lsc-live.box.com/s/gn0pipbeqwyvzktnt5cnhztmmww29vgr', //Louisiana
  '23': 'https://lsc-live.box.com/s/ha6aaacjrvkwrjpyghcfp1u9p18vcy4m', //Maine
  '24': 'https://lsc-live.box.com/s/vg3v0j1ss33g08lanl4ob9xh037hncnk', //Maryland
  '25': 'https://lsc-live.box.com/s/kwpwq4x7hu1jqfmv1xuc30lwe9doorp3', //Massachusetts
  '26': 'https://lsc-live.box.com/s/gbr9lknhdwl00uukei8u1b3c6omvblsm', //Michigan
  '27': 'https://lsc-live.box.com/s/661qd70co98iqdyd06ltlf7lsrivm1ka', //Minnesota
  '28': 'https://lsc-live.box.com/s/3etmvkzqk2vfu0vda2rh3xppeqggg9yq', //Mississippi
  '29': 'https://lsc-live.box.com/s/jil8b6lxqf1yneq8gdsh89h7hijhuua3', //Missouri
  '30': 'https://lsc-live.box.com/s/alaeww0vbbh3fermclwq99v9olrzgpgm', //Montana
  '31': 'https://lsc-live.box.com/s/vzazid8g3wyt5qs5mfcjgaxlwzb54stv', //Nebraska
  '32': 'https://lsc-live.box.com/s/txkmmuarr54cocqvxc0cevx2jfowamxu', //Nevada
  '33': 'https://lsc-live.box.com/s/d9ozfev59bhw40dndxrtsiyc7yxl93l0', //New Hampshire
  '34': 'https://lsc-live.box.com/s/1gsg0bntmixevdnxch85nrw8plwty052', //New Jersey
  '35': 'https://lsc-live.box.com/s/w847f95hyt23egpatkrtaarn89fy5utr', //New Mexico
  '36': 'https://lsc-live.box.com/s/8rci74wpmerrkrwrko4ktaiylppfd47i', //New York
  '37': 'https://lsc-live.box.com/s/ir88vtmwfnkmjj8yv2v028gtkrqduxuw', //North Carolina
  '38': 'https://lsc-live.box.com/s/q84q92z8w5toa01lg3ovg1kqico815pk', //North Dakota
  '39': 'https://lsc-live.box.com/s/fm9buu5fdj5wy9xtazmhbqtng3kezhw0', //Ohio
  '40': 'https://lsc-live.box.com/s/p9h39p9tnuwi4dvp53alxk4rlzqoaznc', //Oklahoma
  '41': 'https://lsc-live.box.com/s/4da5290bwmisidvapoy6cro6522stsji', //Oregon
  '42': 'https://lsc-live.box.com/s/0776f4l46dk6tedwvbswmqa08plc1nbc', //Pennsylvania
  '44': 'https://lsc-live.box.com/s/4a5495bywfjggy5s5jrqsjs9fo3csxtu', //Rhode Island
  '45': 'https://lsc-live.box.com/s/xg7of576jl6vd0gznfbfevhuc7rq7ahx', //South Carolina
  '46': 'https://lsc-live.box.com/s/p8dfsgalcluvh5v509bi512xc7l2ifry', //South Dakota
  '47': 'https://lsc-live.box.com/s/u07ytt15umme65r279scrtmqwb4okzyi', //Tennessee
  '48': 'https://lsc-live.box.com/s/jgnqvud39n4cb221590qs6zwyrmdoazz', //Texas
  '49': 'https://lsc-live.box.com/s/37wvr2kzuqqs0eav71oopid80ec2cb2c', //Utah
  '50': 'https://lsc-live.box.com/s/6n03hjhdjf1j8d0rxht5czq7pwh0hpgr', //Vermont
  '51': 'https://lsc-live.box.com/s/oazoyoq1ecpfjap4fez3s2t3n06al5ea', //Virginia
  '53': 'https://lsc-live.box.com/s/y4tgdtql3we1bhm575qab69ev93u53md', //Washington
  '54': 'https://lsc-live.box.com/s/dqoywwyt03atm702d341t8bgufklu6uj', //West Virginia
  '55': 'https://lsc-live.box.com/s/atarunbzjfodzz478wgnvzshy3recujt', //Wisconsin
  '56': 'https://lsc-live.box.com/s/61uxx2ino86pnq5v7tl1adhkvru6dbiv', //Wyoming
  '60': 'https://lsc-live.box.com/s/xp0kf413iyonlt2j8jvxscg1heqywq1n', //American Samoa
  '69': 'https://lsc-live.box.com/s/1xpbfjgtt6hv9w9prorm00mw7du3ggw1', //Micronesia
  '72': 'https://lsc-live.box.com/s/8pzg8fk7um3gi3tbz1jpvhll9j3h02ei', //Puerto Rico
  '78': 'https://lsc-live.box.com/s/yx0pmoezw1g2s7gkojoby7k5oycmgp3a', //Virgin Islands
}

export default snapshotLinks